/**
 * Utility functions for working with fancy quotes in text strings
 */

/**
 * Wraps text in fancy double quotes (U+201C and U+201D)
 * @param text The text to wrap in quotes
 * @returns The text wrapped in fancy double quotes
 */
export const doubleQuote = (text: string): string => {
  return `\u201C${text}\u201D`;
};

/**
 * Wraps text in fancy single quotes (U+2018 and U+2019)
 * @param text The text to wrap in quotes
 * @returns The text wrapped in fancy single quotes
 */
export const singleQuote = (text: string): string => {
  return `\u2018${text}\u2019`;
};

/**
 * Returns a fancy left double quote (U+201C)
 */
export const leftDoubleQuote = "\u201C";

/**
 * Returns a fancy right double quote (U+201D)
 */
export const rightDoubleQuote = "\u201D";

/**
 * Returns a fancy left single quote (U+2018)
 */
export const leftSingleQuote = "\u2018";

/**
 * Returns a fancy right single quote (U+2019)
 */
export const rightSingleQuote = "\u2019";
